
<script setup>

  import { useLocale } from 'vuetify'
  const { t } = useLocale()

</script>

<template>
    <v-timeline side="end" align="start" line-inset="20" truncate-line="start" line-color="primary" class="w-100">
      <v-timeline-item
            v-for="(item, i) in stepper"
            :key="i"
            dot-color="primary"
            :icon="item.icon"
            :size="$vuetify.display.mobile ? 'small' : 'large'"
            fill-dot
            class="w-100"
            opposite
          >
          <template v-slot:opposite>
            <strong class="d-md-block w-100 text-end mt-3 d-none">{{ item.stringdate }}</strong>
          </template>
          <div class="d-flex my-2">
            <div>
              <strong class="d-block d-md-none">{{ item.stringdate }}</strong>
              <strong>{{ item.date }}</strong>
              <div class="text-caption">
                {{ item.time }}
              </div>
            </div>
          </div>
          <v-card class="w-100" data-aos="fade-left">
            <v-card-text class="text-h6 text-md-h5">
              {{item.title}}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text >
              <p v-html="item.text"></p>
            </v-card-text>
          </v-card>
      </v-timeline-item>
    </v-timeline>
</template>
   
<script>
  import { languages } from '@/locales/index.js'

export default {
  name: 'SteppersBookingComponent',
  props:{
    data:{
      type: Object,
      required: true
    }
  },
  data: () => ({
   stepper: null,
  }),
  watch:{
    
  },
  mounted(){
        if(!languages[this.$vuetify.locale.current]){
          this.$vuetify.locale.current = "en";
        }
        this.stepper = languages[this.$vuetify.locale.current].bookingstepper

        this.stepper[0].time = this.$moment().format('HH:mm')
        this.stepper[0].date = this.$moment().format('ddd, DD MMM YYYY')

        this.stepper[1].time = this.$moment(this.data.cancellation).format('HH:mm')
        this.stepper[1].date = this.$moment(this.data.cancellation).format('ddd, DD MMM YYYY')


        this.stepper[2].time = this.$moment(this.data.start_date).subtract(48,'hours').format('HH:mm')
        this.stepper[2].date = this.$moment(this.data.start_date).subtract(48,'hours').format('ddd, DD MMM YYYY')

        this.stepper[3].time = this.$moment(this.data.start_date).subtract(24,'hours').format('HH:mm')
        this.stepper[3].date = this.$moment(this.data.start_date).subtract(24,'hours').format('ddd, DD MMM YYYY')

        this.stepper[4].time = this.$moment(this.data.start_date).format('HH:mm')
        this.stepper[4].date = this.$moment(this.data.start_date).format('ddd, DD MMM YYYY')

  },
  methods:{
    
  }
}
</script>
